import { routes, type ResolvedComponent } from "@kestrel/internal/client";
import { coerseFunctionOrValue } from "../../utils/function";

/**
 *
 *
 *
 *
 *
 */
export async function resolveComponentFromRouteId(
  routeId: string,
  error: unknown | undefined,
  routeList = routes,
  /*                                                          */
): Promise<ResolvedComponent> {
  const route = routeList.filter(Boolean).find((r) => r.path === routeId);

  if (import.meta.env.DEV && !error && !route) {
    throw new Error(`Route: ${routeId} not found`);
  }

  if (import.meta.env.DEV && !error && !route!.component) {
    throw new Error(`Route: ${routeId} has no component function defined`);
  }

  const { default: component, islands } = await coerseFunctionOrValue(
    route?.component ?? { default: undefined, islands: undefined },
  );

  if (import.meta.env.DEV && !component && !error) {
    throw new Error(`Route: ${route!.path} component function did not return a component`);
  }

  return [component, islands ?? {}];
}
